import type { UserOfficeAffiliation } from "le-coffre-resources/dist/Notary";
import { activeOfficeStore } from "@Front/Stores/ActiveOfficeStore";
import { buildStatusUiPayload } from "@Front/Components/DesignSystem/helpers/statusUi";

const GUEST_FOLDERS_SENTINEL = "GUEST_FOLDERS";

function affiliationOfficeUid(affiliation: UserOfficeAffiliation): string | null {
	const uid = affiliation.office_uid ?? affiliation.office?.uid ?? null;
	return typeof uid === "string" && uid.length > 0 ? uid : null;
}

/**
 * Active real-office UIDs for the current user, aligned with backend
 * `loadActiveAffiliatedRealOfficeUids` (ACTIVE affiliations, excluding GUEST_FOLDERS).
 */
export function getActiveAffiliatedRealOfficeUidsFromStore(): string[] {
	const list = activeOfficeStore.availableOffices ?? [];
	const out: string[] = [];
	for (const a of list) {
		if (!buildStatusUiPayload(a.status, "ACTIVE").isActive) {
			continue;
		}
		const uid = affiliationOfficeUid(a);
		if (!uid || uid === GUEST_FOLDERS_SENTINEL) {
			continue;
		}
		out.push(uid);
	}
	return out;
}
